<template>
  <div>
    <p>Choisir le mode de jeu</p>
    <button @click="chooseGame(1)" class="bouton3">Par image</button>
    <button @click="chooseGame(2)" class="bouton3">Par nom</button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "chooseGame",
  data() {
    return {
      family: 0,
    };
  },
  computed: {
    ...mapGetters({
      difficulty: "difficulty",
    }),
  },
  mounted() {
    setTimeout(() => {
      switch (this.difficulty) {
        case 1:
          this.$store.commit("changeLife", 5);
          break;
        case 2:
          this.$store.commit("changeLife", 3);
          break;
        case 3:
          this.$store.commit("changeLife", 1);
          break;
      }
      this.$store.commit("resetScore");
    }, 50);
  },
  methods: {
    chooseGame(game) {
      this.$store.commit("chooseGame", game);

      this.$store.commit("activePage", "quizz");
    },
  },
};
</script>
